import ContentLayout from '@/layouts/content-layout'
import ArenaView from '@/sections/arena/view/arena-view'

export default function ArenaPage() {
  return (
    <ContentLayout title="จัดการสนามแข่งขัน">
      <ArenaView />
    </ContentLayout>
  )
}
